/**
 * API + websocket origins, derived from the page the app is served from.
 *
 * In production the SPA and the API share one nginx origin (nginx routes
 * `/api/v1` and `/socket.io` to the backend), so the browser's own
 * `window.location.protocol` + `window.location.host` is the correct base.
 * Deriving it at runtime keeps the built bundle host-independent: the same
 * image works on any host, port or scheme with no rebuild.
 *
 * `VITE_API_BASE_URL` / `VITE_WS_URL` remain as overrides for local development,
 * where Vite serves the SPA on a different port than the API.
 *
 * Note: the base must stay ABSOLUTE. `services/api/endpoints.js` bakes it into
 * every endpoint constant and `lib/axios.js` also uses it as `baseURL`; axios
 * skips `baseURL` only for absolute URLs, so a relative base is applied twice
 * (`/api/v1/api/v1/...`).
 */

/** `http://host:port` of the page currently being viewed. */
function currentOrigin() {
    if (typeof window === 'undefined' || !window.location?.host) return '';
    const { protocol, host } = window.location;
    return `${protocol}//${host}`;
}

const stripTrailingSlash = (value) => String(value ?? '').replace(/\/$/, '');

/** Absolute API base, e.g. `http://196.189.247.234/api/v1`. */
export const API_BASE_URL = stripTrailingSlash(
    import.meta.env.VITE_API_BASE_URL || `${currentOrigin()}/api/v1`,
);

/** Absolute socket.io origin, e.g. `http://196.189.247.234`. */
export const WS_URL = stripTrailingSlash(
    import.meta.env.VITE_WS_URL || currentOrigin(),
);
